import {Skeleton} from "primereact/skeleton";

export default function BigInfoCard(props) {
	return (
		<div className="col p-0">
			<div className="card border-0 my-2 b-radius b-shadow">
				<div className="card-body">
					<div className="d-flex flex-row align-items-center">
						<div
							className={
								`round-40 fs-3 opacity-75 rounded-circle text-white d-flex align-items-center justify-content-center p-3 ` +
								`${props.color}`
							}>
							{props.icon}
						</div>
						<div className="ms-3 align-self-center">
							{props.digits ? (
								<>
									<h3 className="mb-0 fs-4">{props.digits}</h3>
									<span className="text-muted fs-6">{props.title}</span>
								</>
							) : (
								<Skeleton height="2rem" className="mb-2"></Skeleton>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
